import React, { useState } from 'react';
import { Icon, Form, Popover, Input, message, Button } from 'antd';
import { uploadUrl, BaseService } from '@/service';
import { useWatchState } from '@/store';
import { Upload, FileList } from '@/components';
import { createFilePath, checkResult } from '@/common';
import "./style.less";

const { TextArea } = Input

const App = Form.create({ name: 'register' })(({ className = "", form, itemId, itemType, userId, pushWechatId, pushGroupId, orgId }) => {

    const { getFieldDecorator } = form;

    const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
    const [[wxUser]] = useWatchState(["wxUser"]);
    const [loading, setLoading] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [files, setFiles] = useState([]);

    const handleSubmit = (e) => {
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                addFeedback(values);
            }
        });
    };

    const addFeedback = vo => {
        setLoading(true);
        BaseService.add({
            table: "thtt_feedback",
            data: {
                push_wechat_id: pushWechatId,
                push_group_id: pushGroupId,
                org_id: orgId,
                openid: wxUser.openid,
                wechat_name: wxUser.userInfo ? wxUser.userInfo.nickname : "",
                user_id: wxUser.user_id,
                item_id: itemId, item_type: itemType,
                ...vo,
                files: JSON.stringify(files),
                add_time: new Date().format("yyyy-MM-dd hh:mm:ss")
            }
        }).then(res => {
            setLoading(false);
            if (!checkResult(res)) return;
            message.success("您的反馈提交成功，我们会尽快与您联系！");
            form.setFieldsValue({
                phone: "",
                name: "",
                remark: "",
            })
            setFiles([]);
            setShowForm(false);
        }, err => setLoading(false))
    }

    const onChangeShowForm = () => setShowForm(!showForm);

    const onUploadFileFinish = e => {
        setFiles([...files, ...e.file.response.files.map(({ fileShowName, url }) => ({ name: fileShowName, url }))])
    }
    const onRemoveFile = e => {
    }

    const content = (
        <Form id="feedForm" className="com-feedback__form" onSubmit={handleSubmit}>
            <Form.Item label="联系方式">
                {getFieldDecorator('phone', {
                    rules: [
                        {
                            required: true,
                            message: '请输入联系方式！',
                        },
                    ],
                })(<Input placeholder="请输入联系方式" />)}
            </Form.Item>
            <Form.Item label="姓名">
                {getFieldDecorator('name', {
                    rules: [
                        {
                            required: true,
                            message: '请输入姓名！',
                        },
                    ],
                })(<Input placeholder="请输入姓名" />)}
            </Form.Item>
            <Form.Item label="反馈意见">
                {getFieldDecorator('remark', {
                    rules: [
                        {
                            required: true,
                            message: '请输入反馈意见！',
                        },
                    ],
                })(<TextArea rows={3} placeholder="请输入反馈意见" />)}
            </Form.Item>
            <Form.Item label="附件">
                <FileList data={files.map(o => ({ ...o, url: createFilePath(o.url, UPLOAD_SERVER_HOST) }))} onRemove={onRemoveFile} />
                <Upload
                    name="files"
                    className="full"
                    onFinish={onUploadFileFinish}
                    action={uploadUrl}
                    showUploadList={false}>
                    <button className="com-feedback__file-btn" type="button"><Icon type="plus" /></button>
                </Upload>
            </Form.Item>
        </Form>
    )

    return (
        <div className={`com-feedback ${showForm && "com-feedback--showForm"} ${className}`}>
            <Popover placement="topRight" style={{ width: "80vw", left: "0" }} visible={showForm} title="反馈" content={content} trigger="click">
                <Button loading={loading} className="com-feedback__topBtn" onClick={onChangeShowForm}>{showForm ? <Icon type="close" /> : "反馈"}</Button>
                <Button loading={loading} className="com-feedback__bomBtn" form="feedForm" onClick={handleSubmit}><Icon type="check" /></Button>
            </Popover>
        </div>
    );
})

export default App;